import React, { Component } from 'react';
import { Row, Col, Radio } from 'antd';
import { keyBy, forEach, concat, filter, get, compact, map } from 'lodash';
import uuidv1 from 'uuid/v1';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import boxes from 'data/boxes';
import { connect } from 'react-redux';

import { autoSaveRequest, getAutoSaveRequest } from 'ducks/shipments';
import { getAddressesRequest } from 'ducks/users';

import helpers from 'utils/helpers';
import ItemCard from './ItemCard';
import {
  NextButton,
  StyledButton,
  StyledRadioGroupHorizontal
} from 'components/Styled';
import categories from 'data/categories';
import InfoBar from 'components/common/InfoBar';

import Popup from 'components/common/Popup';

import ImageAlcohol from 'assets/images/forbidden-items/alcohol.png';
import ImageAlcohol2x from 'assets/images/forbidden-items/alcohol@2x.png';
import ImageAlcohol3x from 'assets/images/forbidden-items/alcohol@3x.png';
import ImageBattery from 'assets/images/forbidden-items/battery.png';
import ImageBattery2x from 'assets/images/forbidden-items/battery@2x.png';
import ImageBattery3x from 'assets/images/forbidden-items/battery@3x.png';
import ImageChampagne from 'assets/images/forbidden-items/champagne.png';
import ImageChampagne2x from 'assets/images/forbidden-items/champagne@2x.png';
import ImageChampagne3x from 'assets/images/forbidden-items/champagne@3x.png';
import ImageFood from 'assets/images/forbidden-items/food.png';
import ImageFood2x from 'assets/images/forbidden-items/food@2x.png';
import ImageFood3x from 'assets/images/forbidden-items/food@3x.png';
import ImageLiquid from 'assets/images/forbidden-items/liquid.png';
import ImageLiquid2x from 'assets/images/forbidden-items/liquid@2x.png';
import ImageLiquid3x from 'assets/images/forbidden-items/liquid@3x.png';
import ImageMedicine from 'assets/images/forbidden-items/medicine.png';
import ImageMedicine2x from 'assets/images/forbidden-items/medicine@2x.png';
import ImageMedicine3x from 'assets/images/forbidden-items/medicine@3x.png';

const keyedCategories = keyBy(categories, 'id');

class Items extends Component {
  state = {
    activeCard: -1,
    items: [],
    itemType: null,
    isDdp: false
  };

  validateAll = () => {
    let success = true;
    let setActive = false;

    forEach(this.state.items, (item, i) => {
      if (!item.ref.current.validate()) {
        success = false;
        if (!setActive) {
          setActive = i;
        }
      }
    });

    if (!success) {
      this.setState(
        {
          activeCard: setActive
        },
        () => {
          setTimeout(helpers.scrollToError, 300);
        }
      );
    }

    return success;
  };

  handleNext = () => {
    if (!this.validateAll()) {
      return;
    }

    if (this.state.activeCard !== -1) {
      this.state.items[this.state.activeCard].ref.current.handleConfirmClick(); // click for trigger tag
    }

    const itemsData = [];
    const { itemType, isDdp } = this.state;
    const itemCategory = [];

    forEach(this.state.items, item => {
      var thisItem = item.ref.current.getItemData();
      itemsData.push(thisItem);
      if (keyedCategories[thisItem.category]) {
        itemCategory.push(keyedCategories[thisItem.category].name.en);
      }
    });

    let currency;
    for (let i = 0; i < itemsData.length; i++) {
      if (currency && currency !== 'auto') break;
      currency = itemsData[i].currency;
    }

    if (currency === 'auto') currency = this.props.currency;

    for (let i = 0; i < itemsData.length; i++) {
      // temp disable fedex over 300kg masks
      if (
        itemsData[i].mainCategory === '121' &&
        (this.props.carrier === 'fedex' || this.props.carrier === 'tnt') &&
        this.props.boxData.previewWeight >= 100 &&
        (this.props.destination === 'US' ||
          this.props.destination === 'CA' ||
          this.props.destination === 'MX')
      ) {
        if (
          this.props.user !== '30c289fb-0386-48cd-bf1c-c2d214e5efb1' &&
          this.props.user !== 'ca677251-6192-494f-a624-c42b79f69c33' &&
          this.props.user !== 'ebf98081-49a3-4c43-9271-ef391fe44c28'
        ) {
          // this.openStaticPopup(this.getDisablePopup());
          // return;
        }
      }

      if (itemsData[i].currency === 'auto') itemsData[i].currency = currency;

      if (itemsData[i].currency !== currency) {
        helpers.message.error(
          this.props.t('items.err_msg.general.inconsistent'),
          'items'
        );
        return;
      }
    }

    const declarationType =
      itemType.charAt(0).toUpperCase() +
      itemType.substring(1).replace('_', ' ');
    window.dataLayer.push({
      event: 'Submit Declaration',
      ecommerce: undefined,
      itemsData: {
        declarationType,
        itemCategory,
        itemDescription: itemsData.map(x => x.description),
        itemQuantity: itemsData.map(x => x.quantity),
        itemValue: itemsData.map(x => x.value),
        itemCurrency: itemsData.length > 0 ? itemsData[0].currency : 'N/A'
      }
    });

    this.props.handleNext({
      itemsData,
      itemType,
      isDdp
    });
  };

  handleActiveCardChange = i => {
    if (!this.validateAll()) {
      return;
    }

    this.setState({
      activeCard: i
    });
  };

  addCard = (data = {}, active = true) => {
    if (!this.validateAll()) {
      return;
    }

    const ref = React.createRef();
    const key = uuidv1();
    this.setState(state => {
      const { items } = state;

      return {
        items: concat(state.items, { ref, key, data }),
        activeCard: active ? items.length : -1
      };
    });
  };

  handleClickAddItem = () => {
    window.dataLayer.push({ event: 'Add New Product', ecommerce: undefined });
    this.setState({
      activeCard: -1
    });
    setTimeout(this.addCard, 300);
  };

  removeCard = i => {
    let { items, activeCard } = this.state;
    if (items.length <= 1) {
      helpers.message.error(
        this.props.t('items.err_msg.general.empty'),
        'items'
      );
      return;
    }

    if (activeCard === i) {
      activeCard = -1;
    }

    if (activeCard > i) {
      activeCard--;
    }

    this.setState(
      state => {
        return {
          items: filter(state.items, (item, index) => {
            return index !== i;
          }),
          activeCard
        };
      },
      () => {
        this.autoSave();
      }
    );
  };

  autoSave = () => {
    const itemsData = [];
    const { itemType } = this.state;

    forEach(this.state.items, item => {
      itemsData.push(item.ref.current.getItemData());
    });

    this.props.autoSaveRequest({
      itemsData,
      itemType
    });
  };

  infoBarTitle = () => {
    const raw = this.props.t('items.customs_alert');
    return {
      __html: raw
    };
  };

  infoBarContent = () => {
    const raw = this.props.t('items.customs_alert_desc');
    return {
      __html: raw
    };
  };

  handleChange = e => {
    this.setState(
      {
        itemType: e.target.value
      },
      () => {
        this.autoSave();
      }
    );
  };

  handleIsDdpChange = e => {
    this.setState({
      isDdp: e.target.value
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !prevProps.getAutoSaveFinished &&
      this.props.getAutoSaveFinished &&
      !this.state.items.length
    ) {
      const { recoverFormData } = this.props;
      console.log('recoverFormData', recoverFormData);
      if (recoverFormData.itemsData && recoverFormData.itemsData.length) {
        forEach(recoverFormData.itemsData, item => {
          this.addCard(item, false);
        });

        if (recoverFormData.itemsData.length === 1) {
          this.setState({
            activeCard: 0
          });
        }
      } else if (!this.state.items.length) {
        this.addCard();
      }

      if (recoverFormData.itemType) {
        this.setState({
          itemType: recoverFormData.itemType
        });
      }
    }
  }

  componentDidMount() {
    this.props.getAutoSaveRequest();

    this.setState({
      itemType:
        this.props.userType === 'business' ? 'commercial_use' : 'personal_use'
    });

    this.props.getAddressesRequest({
      origin: this.props.origin,
      destination: this.props.destination
    });

    window.dataLayer.push({
      event: 'Land Declaration Page',
      ecommerce: undefined
    });

    this.props.handler.openPopup(filter(this.props.posts, ['page', 'ITEMS']));
    this.openForbiddenItemsPopup(this.getForbiddenItemsPopup());
  }

  getDisablePopup = () => {
    return [
      {
        id: 0,
        content: (
          <div
            style={{
              fontSize: '12px',
              padding: '20px 20px 10px',
              textAlign: 'center'
            }}>
            <div style={{ fontSize: '30px' }}>😷</div>
            <div
              style={{
                color: '#57D7DD',
                fontSize: '24px',
                padding: '10px 0 15px',
                fontWeight: 700
              }}>
              {this.props.t('key') === 'en'
                ? 'Shipping Restrictions'
                : '寄件限制'}
            </div>
            <div
              style={{ textAlign: 'center' }}
              dangerouslySetInnerHTML={{
                __html:
                  this.props.t('key') === 'en'
                    ? 'FedEx / TNT has suspended shipments for masks and personal protective equipment which chargeable weight is <span style="font-weight: 700;">100kg</span> or over. Please choose other courier service.'
                    : 'FedEx / TNT暫停<span style="font-weight: 700;">100公斤</span>或以上的口罩及個人防護用品寄件服務，請選擇其他快遞服務。'
              }}></div>
          </div>
        )
      }
    ];
  };

  openStaticPopup = popups => {
    this.setState({
      popupKey: !this.state.popupKey,
      popups: popups
    });
  };

  openForbiddenItemsPopup = forbiddenItemPopups => {
    this.setState({
      forbiddenItemPopupKey: !this.state.forbiddenItemPopupKey,
      forbiddenItemPopups: forbiddenItemPopups
    });
  };

  getForbiddenItemsPopup = () => {
    return [
      {
        id: 0,
        content: (
          <div
            style={{
              fontSize: this.props.t('key') === 'en' ? '11px' : '12px',
              padding: '20px 20px 0',
              textAlign: 'center',
              lineHeight: '20px'
            }}>
            <div
              style={{
                fontSize: '18px',
                fontWeight: 700,
                color: '#57D7DD',
                textAlign: 'center',
                marginBottom: '10px',
                marginTop: '10px'
              }}
              className="buttonTheme-color">
              {this.props.t('items.forbidden_alert_reminder')}
            </div>
            <div
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#57D7DD',
                textAlign: 'center',
                paddingBottom: '20px'
              }}
              className="buttonTheme-color">
              {this.props.t('items.forbidden_alert_title')}
            </div>
            {this.props.carrier === 'skynet' ? (
              <>
                <Row style={{ justifyContent: 'center', marginBottom: '20px' }}>
                  <div style={{ height: '30px', width: '80px' }}>
                    {helpers.responsiveImage(helpers.getCarrierImage('skynet'))}
                  </div>
                </Row>
                <Row style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                  <Col span={6}>
                    {helpers.responsiveImage({
                      '1x': ImageAlcohol,
                      '2x': ImageAlcohol2x,
                      '3x': ImageAlcohol3x
                    })}
                  </Col>
                  <Col span={6}>
                    {helpers.responsiveImage({
                      '1x': ImageMedicine,
                      '2x': ImageMedicine2x,
                      '3x': ImageMedicine3x
                    })}
                  </Col>
                  <Col span={6}>
                    {helpers.responsiveImage({
                      '1x': ImageFood,
                      '2x': ImageFood2x,
                      '3x': ImageFood3x
                    })}
                  </Col>
                  <Col span={6}>
                    {helpers.responsiveImage({
                      '1x': ImageBattery,
                      '2x': ImageBattery2x,
                      '3x': ImageBattery3x
                    })}
                  </Col>
                </Row>
                <div
                  style={{
                    padding: '15px 35px 0px 35px',
                    fontWeight: 700
                  }}>
                  {this.props.t('items.forbidden_alert_skynet')}
                </div>
              </>
            ) : this.props.carrier === 'aramex' ? (
              <>
                <Row style={{ justifyContent: 'center', marginBottom: '10px' }}>
                  <div style={{ height: '30px', width: '80px' }}>
                    {helpers.responsiveImage(helpers.getCarrierImage('aramex'))}
                  </div>
                </Row>
                <Row style={{ paddingLeft: '60px', paddingRight: '60px' }}>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageBattery,
                      '2x': ImageBattery2x,
                      '3x': ImageBattery3x
                    })}
                  </Col>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageChampagne,
                      '2x': ImageChampagne2x,
                      '3x': ImageChampagne3x
                    })}
                  </Col>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageMedicine,
                      '2x': ImageMedicine2x,
                      '3x': ImageMedicine3x
                    })}
                  </Col>
                </Row>
                <Row style={{ paddingLeft: '100px', paddingRight: '100px' }}>
                  <Col span={12}>
                    {helpers.responsiveImage({
                      '1x': ImageFood,
                      '2x': ImageFood2x,
                      '3x': ImageFood3x
                    })}
                  </Col>
                  <Col span={12}>
                    {helpers.responsiveImage({
                      '1x': ImageLiquid,
                      '2x': ImageLiquid2x,
                      '3x': ImageLiquid3x
                    })}
                  </Col>
                </Row>
                <div
                  style={{
                    padding: '15px 35px 0px 35px',
                    fontWeight: 700
                  }}>
                  {this.props.t('items.forbidden_alert_aramex')}
                </div>
              </>
            ) : (
              <>
                <Row style={{ paddingLeft: '60px', paddingRight: '60px' }}>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageAlcohol,
                      '2x': ImageAlcohol2x,
                      '3x': ImageAlcohol3x
                    })}
                  </Col>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageMedicine,
                      '2x': ImageMedicine2x,
                      '3x': ImageMedicine3x
                    })}
                  </Col>
                  <Col span={8}>
                    {helpers.responsiveImage({
                      '1x': ImageFood,
                      '2x': ImageFood2x,
                      '3x': ImageFood3x
                    })}
                  </Col>
                </Row>
                <div
                  style={{
                    padding: '15px 35px 0px 35px',
                    fontWeight: 700
                  }}>
                  {this.props.t(
                    this.props.carrier === 'tnt'
                      ? 'items.forbidden_alert_tnt'
                      : 'items.forbidden_alert_general'
                  )}
                </div>
              </>
            )}
            <div
              style={{
                padding: '0px 35px 0px 35px'
              }}>
              {this.props.t('items.forbidden_alert_contact')}
            </div>
            {this.props.carrier === 'aramex' ? (
              <div
                style={{
                  padding: '0px 35px 0px 35px',
                  fontWeight: 700
                }}>
                {this.props.t('items.forbidden_alert_fine_aramex')}
              </div>
            ) : (
              <div
                style={{
                  padding: '0px 35px 0px 35px',
                  fontWeight: 700
                }}>
                {this.props.t('items.forbidden_alert_fine')}
              </div>
            )}
          </div>
        )
      }
    ];
  };

  render() {
    if (this.props.redirect) {
      this.props.determineBusinessOrPersonal(0);
      return null;
    }

    const boxData = get(this.props.quotation, 'boxData.boxes');
    const { envelope } = boxes;
    let showDocument = true;

    forEach(boxData, b => {
      if (
        b.length > envelope.length ||
        b.width > envelope.width ||
        b.height > envelope.height
      ) {
        showDocument = false;
      }
    });

    return (
      <div
        className="quotation-content"
        style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          overflowX: 'hidden',
          backgroundColor: '#fafafa',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <InfoBar
          title={this.infoBarTitle()}
          content={this.infoBarContent()}
          t={this.props.t}
        />
        <div style={{ flex: '1 0 auto' }}>
          <div style={{ padding: '25px 15px 20px' }}>
            <Row type="flex" align="middle">
              <span
                className="buttonSecond-color"
                style={{
                  color: '#57D7DD',
                  fontSize: '24px',
                  fontWeight: 700
                }}>
                {this.props.t('items.taxHandling.title')}
              </span>
            </Row>
            <Row style={{ marginTop: '5px' }}>
              <StyledRadioGroupHorizontal
                size="large"
                value={this.state.isDdp}
                onChange={this.handleIsDdpChange}>
                {(() => {
                  return (
                    <>
                      <Radio value={true}>
                        {this.props.t('items.taxHandling.ddp')}
                      </Radio>
                      <Radio value={false}>
                        {this.props.t('items.taxHandling.ddu')}
                      </Radio>
                    </>
                  );
                })()}
              </StyledRadioGroupHorizontal>
            </Row>
          </div>
          <div style={{ padding: '25px 15px 20px' }}>
            <Row type="flex" align="middle">
              <span
                className="buttonSecond-color"
                style={{
                  color: '#57D7DD',
                  fontSize: '24px',
                  fontWeight: 700
                }}>
                {this.props.t('items.item_detail')}
              </span>
            </Row>
            <Row style={{ marginTop: '5px' }}>
              <StyledRadioGroupHorizontal
                size="large"
                value={this.state.itemType}
                onChange={this.handleChange}>
                {(() => {
                  let itemTypeList = [
                    'commercial_use',
                    'sample_use',
                    'return_goods',
                    'personal_use'
                  ];
                  if (this.props.userType !== 'business') {
                    itemTypeList = ['personal_use', 'return_goods'];
                  }

                  return compact(
                    map(itemTypeList, i => {
                      return (
                        <Radio key={i} value={i}>
                          {this.props.t(`items.${i}`)}
                        </Radio>
                      );
                    })
                  );
                })()}
              </StyledRadioGroupHorizontal>
            </Row>
          </div>
          <div>
            <TransitionGroup>
              {this.state.items.map((item, index) => (
                <CSSTransition
                  key={item.key}
                  timeout={300}
                  classNames="fade-element">
                  <ItemCard
                    t={this.props.t}
                    key={item.key}
                    index={index}
                    ref={item.ref}
                    data={item.data}
                    itemCurrency={this.props.currency}
                    expand={this.state.activeCard === index}
                    changeActiveCard={this.handleActiveCardChange}
                    removeCard={this.removeCard}
                    autoSave={this.autoSave}
                    showDocument={showDocument}
                    itemType={this.state.itemType}
                  />
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
          <div
            style={{
              padding: '30px 15px',
              textAlign: 'center'
            }}>
            <StyledButton
              ghost
              type="secondary"
              className="theme-button"
              width={165}
              onClick={this.handleClickAddItem}>
              {this.props.t('button.add_item')}
            </StyledButton>
          </div>
        </div>
        <div>
          <NextButton
            block
            step="true"
            type="primary"
            height={60}
            onClick={this.handleNext}
            loading={this.props.loading}>
            {this.props.t('button.next_step')}
          </NextButton>
        </div>
        {this.state.popups && (
          <Popup
            key={!!this.state.popupKey}
            popups={this.state.popups}
            buttonText={
              this.props.t('key') === 'en' ? 'Please quote again' : '請重新報價'
            }
            maxWidth={300}
            action={() => {
              this.props.history.push(
                `/${localStorage.i18nextLng}/create-shipment/quotation`
              );
            }}
          />
        )}
        {this.state.forbiddenItemPopups && (
          <Popup
            key={!!this.state.forbiddenItemsPopupKey}
            popups={this.state.forbiddenItemPopups}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  getAutoSaveRequest,
  autoSaveRequest,
  getAddressesRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    getAutoSaveFinished: !!state.shipments.getAutoSaveFinished,
    recoverFormData: state.shipments.recoverFormData || {},
    userType: state.auth.userType,
    posts: state.shipments.posts || false
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Items))
);
